export default __webpack_public_path__ + "static/media/avatar-gray.ef863cef.svg";